import languages from "@/assets/JSFiles/Languages.json";

export const mVMixin = {
    methods: {
        getclassChange(value) {
            return value ? 'red' : 'not-red'
        },
        formatDate(timeStr) {
            let temp = new Date(timeStr)
            let newFormat = ''
            if (temp instanceof Date && !isNaN(temp)) {
                let monthNames = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']
                let date = temp.getDate()
                let month = monthNames[temp.getMonth()]
                let year = temp.getFullYear()
                if (date < 10) {
                    date = '0' + '' + date
                }
                newFormat = date + '-' + month + '-' + year
            } else {
                temp = timeStr.split(/(\s+)/)[0].split('-').reverse()
                let month = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']
                temp[1] = month[parseInt(temp[1]) - 1]
                newFormat = temp.join('-')
                if (newFormat.charAt(0) === '0') {
                    newFormat = newFormat.slice(1)
                }
            }
            return newFormat
        },
        formatTime(timeStr) {
            let temp = new Date(timeStr)
            let timeFormat = ''
            if (temp instanceof Date && !isNaN(temp)) {
                let temp1 = ''
                if (timeStr.split(' ')[1]) {
                    temp1 = timeStr.split(' ')[1]
                } else if (timeStr.split('T')[1]) {
                    temp1 = timeStr.split('T')[1]
                    temp1 = temp1.split('.')[0]
                }
                timeFormat = temp1
            } else {
                let temp1 = ''
                if (timeStr.split(/(\s+)/)[2]) {
                    temp1 = timeStr.split(/(\s+)/)[2]
                }
                timeFormat = temp1
            }
            return timeFormat
        },
        apiDateFormat(timeStr) {
            let temp = new Date(timeStr)
            let newFormat = ''
            if (temp instanceof Date && !isNaN(temp)) {
                let date = temp.getDate()
                let month = temp.getMonth() + 1
                let year = temp.getFullYear()
                if (date < 10) {
                    date = '0' + '' + date
                }
                if (month < 10) {
                    month = '0' + '' + month
                }
                newFormat = year + '-' + month + '-' + date
            }
            return newFormat
        },
        convertDate(val) {
            if (val) {
                var event = new Date(val)
                let date = JSON.stringify(event)
                date = date.slice(1, 11)
                return date
            } else {
                return ''
            }
        },
        actResponseConversion(arr) {
            this.actMakeSizeConversion(arr)

            let item = this.setUniqueId(arr)
            return item

        },
        setUniqueId(arr) {
            return arr.map((item, index) => {
                item.checkid = item.filename
                return item;
            })
        },
        actMakeSizeConversion(arr) {
            return arr.map((item) => {
                if (!(item.size.toString().includes('MB') || item.size.toString().includes('GB'))) {
                    item.size = (parseInt(item.size) / (1024 * 1024)).toFixed(2);
                    item.size = item.size + ' ' + 'MB'
                    if (item.size > 1024) {
                        item.size = item.size + ' ' + 'GB'
                    }
                    return item;
                } else {
                    return item
                }
            })

        },
        filterParam(filterValue, concatData) {
            for (let data in filterValue) {
                if (typeof(filterValue[data]) === "object") {
                    console.log(filterValue[data])
                    concatData = this.filterParam(filterValue[data], concatData)
                } else {
                    let res = `${data}=${filterValue[data]}&`
                    concatData = concatData.concat(res)
                }
            }
            return concatData
                // console.log("ConcatBefore||", concatData)
                // let splitStr = concatData.split('&')
                // console.log("length", splitStr.length)
                // splitStr.splice(splitStr.length - 1, 1)
                // console.log("ConcatAfter||", splitStr)

        },
        getParam(param) {
            let concatData = ""
            return this.filterParam(param, concatData)

        },
        getLanguage(filename, filetype) {
            // console.log(filename, filetype)
            if(filetype === 'SUBTITLE'){
             let language = { name: "", code: "" };
             let lang = typeof(filename) === "string" ? filename.split("_") : "";
             if (lang) {
                let newValue = JSON.parse(lang) 
                lang = newValue['SUBTITLE']['language']
                console.log("lang", lang);
                languages.forEach(value => {
                    if (lang.toLowerCase() === value["alpha3-b"]) {
                        language.name = value.English.toUpperCase();
                        language.code = value["alpha3-b"];
                    }
                });
            }
            return language;
            }else{
             let language = { name: "", code: "" };
             let lang = typeof(filename) === "string" ? filename.split("_") : "";
             if (lang) {
                lang = lang[lang.length - 1].split(".")[0];
                console.log("lang", lang);
                languages.forEach(value => {
                    if (lang.toLowerCase() === value["alpha3-b"]) {
                        language.name = value.English.toUpperCase();
                        language.code = value["alpha3-b"];
                    }
                });
            }
            return language;

            }

        },
        checkTokenExpiry(error) {
            caches.delete('vlive-v1').then(rep => {
                console.log(rep)
            })
            if ((error.errorcode == 407 || error.errorcode == 302 || error.errorcode == 401)) {
                // let url = error.reason && error.reason.includes("https") ? error.reason : 'https://vlive-cms.firebaseapp.com'
                console.log("BUILDTYPE===>", BUILDTYPE)
                let url = "https://vauthprovider-529d8.web.app/"
                if (BUILDTYPE == 'PROD') {
                    url = 'https://vauth.mobiotics.com'
                }

                let redirectUrl = `${url}?serviceurl=${window.location.origin}&servicename=vdrm`;
                console.log("redirect", redirectUrl);
                localStorage.clear()
                sessionStorage.clear()
                window.location.replace(redirectUrl);
            }
        },
        toHHMMSS(duration) {
            var sec_num = parseInt(duration, 10); // don't forget the second param
            var hours = Math.floor(sec_num / 3600);
            var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
            var seconds = sec_num - (hours * 3600) - (minutes * 60);

            if (hours < 10) { hours = "0" + hours; }
            if (minutes < 10) { minutes = "0" + minutes; }
            if (seconds < 10) { seconds = "0" + seconds; }
            return hours + ':' + minutes + ':' + seconds;
        },
        getFileSize(size) {
            if(size != null) {
                if (!(size.toString().includes('MB') || size.toString().includes('GB'))) {

                    size = (parseInt(size) / (1024 * 1024)).toFixed(2);
                    size = size + " " + "MB";
    
                    if (parseInt(size) > 1024) {
                        size = size + " " + "GB";
                    }
                    return size;
                } else {
                    return size
                }
            } else {
                console.log(size,"false getFileSize")
                return "-----"
            }
        },
        sizeConverterToBytes(size) {
            if (size.toString().includes('MB')) {
                size = Math.round((parseFloat(size) * (1024 * 1024)))
            } else if (size.toString().includes('GB')) {
                size = Math.round((parseFloat(size) * (1024 * 1024 * 1024)))
            }
            return size
        },
        checkRedundant(arr) {
            console.log("Array", arr)
            let result = []
            result = arr.reduce((unique, currentval) => {
                if (!unique.some(obj => obj.checkid === currentval.checkid)) {
                    unique.push(currentval);
                }
                return unique;
            }, []);
            console.log("res>>", result);
            return result;
        },
        getArrValue(value) {
            if (value) {
                return value.map(ele => {
                    return ele && ele.filename ? ele.filename : ele
                        // return `{filename:${ele.filename},language:${ele.language}}`;
                });
            } else {
                return "";
            }
        },
        getFilterValues(data){
            let subData = {};
           for (var key in data) {
           if (data[key] !== undefined && data[key] !== "")
          subData[key] = data[key];
        }
        return subData
        }

    }
}


// WEBPACK FOOTER //
// ./src/mixins.js